/* Function
DESC: General utility functions
*/

import { publicPortals } from '../consts';

export function isStringDefinedAndNotEmpty(str: string): boolean {
  return typeof str !== 'undefined' && str !== '';
}

//function to avoid runtime errors when importing the config below
export function getEnvVar(v: string): string {
  const ret = process.env[v];

  if (ret === undefined) {
    throw new Error('process.env.' + v + ' is undefined!');
  }
  return ret;
}

export function is404(basename: any): boolean {
  const path = window.location.pathname;
  const isInternal = basename === 'internal';

  const allowedInternalPaths = [
    '/internal',
    '/internal/',
    '/internal/analysis',
    '/internal/analysis/',
    '/internal/login',
    '/internal/login/',
  ];

  const isNonPublic =
    basename && basename !== 'internal' && !publicPortals.includes(basename);
  const isPublic = publicPortals.includes(basename);

  const allowedPublicPaths = [
    `/${basename}`,
    `/${basename}/`,
    `/${basename}/today`,
    `/${basename}/today/`,
    `/${basename}/analysis`,
    `/${basename}/analysis/`,
  ];

  return (
    (isInternal && !allowedInternalPaths.includes(path)) ||
    isNonPublic ||
    (isPublic && !allowedPublicPaths.includes(path))
  );
}
